module.exports = __webpack_public_path__ + "img/77283.00b41208.svg";